import { http } from "@/http/http.js";

export default {
	// 查看项目经理工单
	queryManagerOrderInfo(data) {
		return http.post("/mp/busOrder/queryManagerOrderInfo", data);
	},

	// 查询项目班组信息
	queryProjectGroup(data) {
		return http.post("/mp/busOrder/queryProjectGroup", data);
	},

	// 查询工作任务类型
	queryBusWorkInfo(data) {
		return http.post("/mp/busOrder/queryBusWorkInfo", data);
	},

	// 查询额外流动车辆
	queryFlowCarInfo(data) {
		return http.post("/mp/busOrder/queryFlowCarInfo", data);
	},

	// 项目经理发布任务
	addOrderTask(data) {
		return http.post("/mp/busOrder/addOrderTask", data);
	},

	// 项目经理撤回任务
	cancelOrderTask(data) {
		return http.post("/mp/busOrder/cancelOrderTask", data);
	},

	// 根据工单查询任务明细
	queryOrderTaskById(data) {
		return http.post("/mp/busOrder/queryOrderTaskById", data);
	}
};